import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_INTENT_PROJECT } from "./gql";
import { SEARCH_INTENT_PROJECTS } from "../useSearchIntentProjects/gql";

const useDeleteIntentProjectMutation = createDefaultMutationHook(DELETE_INTENT_PROJECT);

const useDeleteIntentProject = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [deleteIntentProjectMutation, { loading }] = useDeleteIntentProjectMutation({
    refetchQueries: [SEARCH_INTENT_PROJECTS],
  });

  const deleteIntentProject = useCallback(
    (id: string, keepResources?: boolean, successCallback?: () => void) => {
      deleteIntentProjectMutation({ id, keepResources: keepResources ?? null }, (data) => {
        if (data?.intentProjectDelete) {
          reportSuccess({
            message: `Intent Project "${data.intentProjectDelete.name}" was successfully deleted`,
          });
          successCallback?.();
        }
      });
    },
    [deleteIntentProjectMutation, reportSuccess]
  );

  return {
    deleteIntentProject,
    loading,
  };
};

export default useDeleteIntentProject;
